module.exports = __webpack_public_path__ + "static/media/banner_consumidor_loja.1c8cde1f.png";